import React from 'react';
import loadable from '@loadable/component';

const ExploreWrapper = loadable(
  () => import(/* webpackChunkName: "ExploreWrapper.loadable" */ 'app/shared/wrappers/ExploreWrapper/component'),
);

class LoadableExploreWrapper extends React.Component {
  render() {
    return <ExploreWrapper {...this.props} />;
  }
}

export default LoadableExploreWrapper;
